import { get, logError } from 'utils';

export default function getAggregatorDetails(
  id,
  onSuccess = () => {},
  onError = () => {},
  onFinally = () => {}
) {
  get(
    { apiKey: 'configure.aggregator.details' },
    { params: { routeParam: id } }
  )
    .then(({ data }) => onSuccess(data))
    .catch(err => {
      logError(err);
      onError(err);
    })
    .finally(onFinally);
}
